import { InjectionToken, Signal } from '@angular/core';

import { TfsIconName } from '@tfs/material/tfs-icon';

export interface DataSyncJob {
  readonly id: string;
  readonly sourceId: string;
  readonly state: 'active' | 'success' | 'error';
  readonly label: string;
  readonly icon: TfsIconName;
}

export interface DataSyncSource {
  readonly id: string;
  readonly jobs: Signal<readonly DataSyncJob[]>;
  dismiss(jobId: string): void;
}

export const DATA_SYNC_SOURCES = new InjectionToken<readonly DataSyncSource[]>(
  'DATA_SYNC_SOURCES',
  { providedIn: 'root', factory: () => [] }
);
